// extracted by mini-css-extract-plugin
export default {"menuBlock":"XI-z","title":"YI-z","nav":"ZI-z","flexCell":"_I-z","facetLink":"aJ-z"};